// extracted by mini-css-extract-plugin
module.exports = {"contacts":"_2YJSJJ","actions":"_2F-bJM","buttons":"_-21yZO","checkbox":"_1sbDdP","sendButton":"_3os4XL","modal":"_1RfeMI","shine-lines":"_2zylHs"};